import script from "./ManageDocuments.vue?vue&type=script&setup=true&lang=ts"
export * from "./ManageDocuments.vue?vue&type=script&setup=true&lang=ts"

import "./ManageDocuments.vue?vue&type=style&index=0&id=969bf2fe&lang=scss"

const __exports__ = script;

export default __exports__